import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeopleIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('resources.people.active');
  }
}

export default instrumentRoutePerformance(ResourcesPeopleIndexRoute);
